module.exports = __webpack_public_path__ + "img/customize_access.a8e54e52.svg";